"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLiquidityHelperAddress = exports.getChainLinkRegistryAddresses = exports.getOracleAddress = exports.getFactoryAddress = exports.getConfig = void 0;
var strategyQueryData_1 = require("../../types/strategyQueryData");
var addresses_1 = __importDefault(require("./addresses"));
var getConfig = function (chainId, config, subConfig, twap, dex) {
    if (!chainId)
        return undefined;
    var addressObj = addresses_1.default[chainId][config][subConfig];
    if (typeof addressObj === 'object') {
        addressObj = dex ? addressObj[dex] : addressObj;
    }
    if (typeof addressObj === 'undefined') {
        throw new TypeError("Config ".concat(config, ".").concat(subConfig, " not found. Options:").concat(Object.entries({ twap: twap, chainId: chainId, dex: dex })
            .map(function (e) { return e.join(':'); })
            .join(', ')));
    }
    if (typeof addressObj === 'string')
        return addressObj;
    var address = ((twap && (addressObj === null || addressObj === void 0 ? void 0 : addressObj.twap)) || addressObj);
    if (!address)
        return undefined;
    if (typeof address === 'string')
        return address;
    return address.default;
};
exports.getConfig = getConfig;
var getFactoryAddress = function (chainId, dataFeed, dex) {
    return (0, exports.getConfig)(chainId, 'defiEdge', 'factoryAddress', dataFeed === strategyQueryData_1.DataFeed.Twap, dex);
};
exports.getFactoryAddress = getFactoryAddress;
var getOracleAddress = function (chainId, isTwap, dex) {
    return (0, exports.getConfig)(chainId, 'defiEdge', 'oracleAddress', isTwap, dex);
};
exports.getOracleAddress = getOracleAddress;
var getChainLinkRegistryAddresses = function (chainId, isTwap, dex) { return (0, exports.getConfig)(chainId, 'defiEdge', 'chainLinkRegistryAddress', isTwap, dex); };
exports.getChainLinkRegistryAddresses = getChainLinkRegistryAddresses;
var getLiquidityHelperAddress = function (chainId, dex, isTwap) {
    return (0, exports.getConfig)(chainId, 'defiEdge', 'liquidityHelperAddress', isTwap, dex);
};
exports.getLiquidityHelperAddress = getLiquidityHelperAddress;
//# sourceMappingURL=functions.js.map